import { Node } from '@craftjs/core'
import axios from 'axios'
import { CSSProperties, useEffect } from 'react'
import { createGlobalStyle } from 'styled-components'
import { Border } from '../types/main'

export const setPixelValue = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, key: string, setProp: (cb: (props: any) => void, throttleRate?: number) => void) => {
  setProp((props: any) => props.style[key] = event.target.value + 'px')
}

export const request = axios.create({
  withCredentials: true, 
  baseURL: process.env.REACT_APP_API_URL
})

export const getRgbaParts = (color: string) => {
  return color.replace(/\s/g, '').match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i)
}

export const rgba2hex = (color: string) => {
  let rgba: any = getRgbaParts(color)

  if (!rgba) return {hex: '#FFFFFF', opacity: 100}

  let hex = (rgba[1] | 1 << 8).toString(16).slice(1) +
    (rgba[2] | 1 << 8).toString(16).slice(1) +
    (rgba[3] | 1 << 8).toString(16).slice(1)

  return {
    hex: `#${hex}`,
    opacity: rgba[4]*100
  }
}

export const getBorder = (border: Border) => {
  if (border && border.sides && border.sides.length !== 0) {
    let style = `${border.width || '3px'} ${border.style || 'solid'} ${border.color || '#000000'}`

    if (border.sides.includes('full')) {
      return { border: style }
    } else {
      let borders: any = {}

      border.sides.forEach(side => borders[side] = style)

      return borders
    }
  }

  return {}
}

export const LoadFont = () => {
  if (!document.fonts.check('16px Segoeuil')) {
    let style_tag = document.createElement('style')
    style_tag.innerHTML = `
      body {
        @font-face {
          font-family: 'Segoeuil';
          src: local('Segoeuil'), url("https://htc-dw-assets-65f4004c87d3.s3.amazonaws.com/segoeuil.ttf");
          font-style: normal;
          font-display: swap;
        };
      }
    `
  
    document.body.appendChild(style_tag)
  }
}

export const getInnerDimensions = (props: any) => {
  let width = props.width ? parseInt(props.width) : null
  let height = parseInt(props.height)

  if (props.border) {
    // ['borderTop', 'borderRight', 'borderBottom', 'borderLeft']
    let border = props.border

    if (border.sides.includes('full')) {
      height -= parseInt(border.width)*2

      if (width) width -= parseInt(border.width)*2
    } else {
      if (border.sides.includes('borderTop')) height -= parseInt(border.height)

      if (border.sides.includes('borderBottom')) height -= parseInt(border.height)

      if (width) {
        if (border.sides.includes('borderLeft')) width -= parseInt(border.width)
  
        if (border.sides.includes('borderRight')) width -= parseInt(border.width)
      }
    }
  }

  if (props.style) {
    if (props.style.padding) {
      height -= parseInt(props.style.padding)*2

      if (width) width -= parseInt(props.style.padding)*2
    } else {
      if (props.style.paddingTop) height -= parseInt(props.style.paddingTop)
      if (props.style.paddingBottom) height -= parseInt(props.style.paddingBottom)

      if (width) {
        if (props.style.paddingLeft) width -= parseInt(props.style.paddingLeft)
        if (props.style.paddingRight) width -= parseInt(props.style.paddingRight)
      }
    }
  }

  let dimensions: {width?: string, height: string} = { height: `${height}px` }

  if (width) dimensions.width = `${width}px`

  return dimensions
}

export const getStyle = (style: CSSProperties, mobileStyle: CSSProperties, device: string, parentNode: Node): CSSProperties => {
  let combined_style = {
    transform: 'scaleX(1) scaleY(1)',
    ...style
  }

  if (device === 'mobile') {
    let multiplier = 36 / (parentNode.data.name === 'Section' ? 36 : parentNode.data.props.grids)

    if (mobileStyle) {
      combined_style = {...combined_style, ...mobileStyle}

      if (!mobileStyle.gridColumnStart) {
        combined_style.gridColumnStart = (parseInt(style.gridColumnStart + '') - 1) * multiplier + 1
      }
    } else if (parentNode.data.name === 'Column') {
      let end = combined_style.gridColumnEnd as string
      combined_style = {
        ...combined_style, 
        gridColumnStart: (parseInt(style.gridColumnStart + '') - 1) * multiplier + 1,
        gridColumnEnd: 'span ' + parseInt(end.replace('span ', '')) * multiplier
      }
    }
  }

  return combined_style
}
